module.exports = __webpack_public_path__ + "img/gray-up-arrow.21e9e06d.svg";